import { useState } from 'react';
import { MessageCircle, Sparkles, Edit3, Info } from 'lucide-react';

const WelcomeMessageConfig = ({ welcomeMessage, onChange }) => {
  const [message, setMessage] = useState(welcomeMessage || '');
  const [charCount, setCharCount] = useState((welcomeMessage || '').length);

  // Templates de mensagens sugeridas
  const messageTemplates = [
    {
      title: 'Profissional',
      message: 'Olá! 👋 Bem-vindo ao nosso atendimento. Como posso ajudar você hoje?'
    },
    {
      title: 'Amigável',
      message: 'Oi! 😊 Que bom ter você aqui! Em que posso te ajudar hoje?'
    },
    {
      title: 'Suporte Técnico',
      message: 'Olá! Sou seu assistente de suporte técnico. Por favor, descreva o problema que está enfrentando.'
    },
    {
      title: 'Vendas',
      message: 'Olá! Que prazer receber você! Estou aqui para te ajudar a encontrar a solução perfeita para suas necessidades.'
    }
  ];

  const handleMessageChange = (value) => {
    setMessage(value);
    setCharCount(value.length);
    onChange(value);
  };

  const applyTemplate = (template) => {
    handleMessageChange(template.message);
  };

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
          <MessageCircle className="w-8 h-8 text-green-600" />
          Mensagem de Boas-Vindas
        </h3>
        
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Info className="w-4 h-4" />
          <span>{charCount}/500 caracteres</span>
        </div>
      </div>

      {/* Descrição */}
      <div className="mb-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-100">
        <p className="text-base text-gray-700 flex items-start gap-2">
          <Sparkles className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          Configure a primeira mensagem que o cliente verá ao abrir o chat. 
          Seja acolhedor e deixe claro como você pode ajudar!
        </p>
      </div>

      {/* Campo de texto */}
      <div className="mb-6">
        <label className="block text-lg font-semibold text-gray-700 mb-3">
          Mensagem Inicial
        </label>
        <div className="relative">
          <textarea
            value={message}
            onChange={(e) => handleMessageChange(e.target.value)}
            className="w-full px-5 py-4 text-base border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-green-100 focus:border-green-500 transition-all resize-none"
            placeholder="Ex: Olá! Sou a Maria, sua assistente virtual. Como posso ajudar você hoje?"
            rows={4}
            maxLength={500}
          />
          <Edit3 className="absolute top-4 right-4 w-5 h-5 text-gray-400 pointer-events-none" />
        </div>
      </div>

      {/* Templates sugeridos */}
      <div>
        <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-green-600" />
          Sugestões de Mensagem
        </h4>
        <div className="grid grid-cols-2 gap-3">
          {messageTemplates.map((template, index) => (
            <button
              key={index}
              onClick={() => applyTemplate(template)}
              className="text-left p-4 bg-gray-50 rounded-xl border-2 border-gray-200 hover:border-indigo-300 hover:bg-indigo-50 transition-all group"
            >
              <div className="font-semibold text-gray-900 mb-2 group-hover:text-green-600 transition-colors">
                {template.title}
              </div>
              <div className="text-sm text-gray-600 line-clamp-2">
                {template.message}
              </div>
            </button>
          ))}
        </div>
      </div>

    </div>
  );
};

export default WelcomeMessageConfig;